import { actions } from "../slice.js";
import { thunkTypes } from "../thunk-types.js";
import { createAsyncThunk } from "@reduxjs/toolkit";
//#region src/redux/transient/thunks/update-transient.ts
var updateTransient = createAsyncThunk(thunkTypes.UPDATE_TRANSIENT, async (param, { dispatch }) => {
	const transient = param.transient;
	if (!transient.key || !transient.value) throw new Error("key or value is missing");
	dispatch(actions.updateTransient({ transients: [{
		key: transient.key,
		value: transient.value
	}] }));
	return transient;
});
//#endregion
export { updateTransient };

//# sourceMappingURL=update-transient.js.map